(() => {
  const setup = (scope = document) => {
    const nodes = scope.querySelectorAll ? scope.querySelectorAll('[data-issui-reveal]') : [];
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach((n) => n.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach((n) => {
      if (!n.dataset.issuiObserved) {
        n.dataset.issuiObserved = 'true';
        io.observe(n);
      }
    });
  };
  const setupMobileBuybar = () => {
    const bar = document.querySelector('[data-issui-mobile-buybar]');
    if (!bar) return;

    const hero = document.querySelector('.issui-v2-hero');
    const buy = document.querySelector('#issui-buy');
    if (!hero || !buy || !('IntersectionObserver' in window)) return;

    let heroVisible = true;
    let buyVisible = false;

    const update = () => {
      bar.classList.toggle('is-visible', !heroVisible && !buyVisible);
    };

    const heroObserver = new IntersectionObserver((entries) => {
      heroVisible = entries.some((entry) => entry.isIntersecting);
      update();
    }, { threshold: 0.08 });

    const buyObserver = new IntersectionObserver((entries) => {
      buyVisible = entries.some((entry) => entry.isIntersecting);
      update();
    }, { threshold: 0.08 });

    heroObserver.observe(hero);
    buyObserver.observe(buy);
  };

  const setupProductBuybar = () => {
    const bar = document.querySelector('[data-issui-product-buybar]');
    const stickyButton = document.querySelector('[data-issui-product-buybar-submit]');
    const originalButton = document.querySelector('.issui-product-page [id^="ProductSubmitButton-"]');
    if (!bar || !stickyButton || !originalButton) return;
    if (bar.dataset.issuiReady === 'true') return;
    bar.dataset.issuiReady = 'true';

    const syncState = () => {
      stickyButton.disabled = originalButton.disabled;
      const label = originalButton.querySelector('span');
      if (label && label.textContent.trim()) stickyButton.textContent = label.textContent.trim();
    };
    syncState();

    stickyButton.addEventListener('click', () => {
      if (!originalButton.disabled) originalButton.click();
    });

    const mutationObserver = new MutationObserver(syncState);
    mutationObserver.observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled']
    });

    const updateVisibility = () => {
      const rect = originalButton.getBoundingClientRect();
      const originalVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      const hasPassedOriginalButton = rect.bottom <= 0;
      bar.classList.toggle('is-visible', !originalVisible && hasPassedOriginalButton);
    };

    updateVisibility();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(updateVisibility, { threshold: 0.05 });
      observer.observe(originalButton);
    }
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
  };

  const setupAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    const clean = (value, max = 100) => value ? value.trim().slice(0, max) : '';
    const source = clean(params.get('utm_source'));
    const medium = clean(params.get('utm_medium'));
    const campaign = clean(params.get('utm_campaign'));
    const content = clean(params.get('utm_content'));

    if (!source && !medium && !campaign && !content) return;

    const signature = [source, medium, campaign, content].join('|');
    try {
      if (sessionStorage.getItem('issui_attribution_sent') === signature) return;
    } catch (_) {}

    const attributes = {};
    if (source) attributes.__issui_source = source;
    if (medium) attributes.__issui_medium = medium;
    if (campaign) attributes.__issui_campaign = campaign;
    if (content) attributes.__issui_content = content;
    attributes.__issui_landing = window.location.pathname.slice(0, 140);

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    const persistAttribution = () => {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes })
      }).then((response) => {
        if (!response.ok) return;
        try {
          sessionStorage.setItem('issui_attribution_sent', signature);
        } catch (_) {}
      }).catch(() => {});
    };

    const schedulePersist = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(persistAttribution, { timeout: 3000 });
      } else {
        window.setTimeout(persistAttribution, 900);
      }
    };

    if (document.readyState === 'complete') schedulePersist();
    else window.addEventListener('load', schedulePersist, { once: true });
  };

  const init = () => {
    setup();
    setupMobileBuybar();
    setupProductBuybar();
    setupAttribution();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', (e) => {
    setup(e.target);
    setupMobileBuybar();
    setupProductBuybar();
  });
})();
